import React from 'react';
import { Transfer, TransferProps } from 'antd';
import classNames from 'classnames';
import styles from './transfer-list.module.scss';

interface Props<T> extends TransferProps<T> {
	className?: string;
}

const TransferList = <T extends object = {}>(props: Props<T>) => {
	const { className, ...otherProps } = props;
	return (
		<div className={classNames(styles.bringgTransfer, className)} data-test-id="bringg-transfer">
			<Transfer {...otherProps} />
		</div>
	);
};

export default TransferList;
